import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogCloseButton,
    AlertDialogContent,
    AlertDialogOverlay,
} from "@chakra-ui/react";
import { useRef } from "react";

type AppAlertMessageProps = {
    children: JSX.Element;
    isOpen: boolean;
    onCancel: () => void;
    size?: string;
};

export const AppAlertMessage = ({
    children,
    isOpen,
    onCancel,
    size = "md",
}: AppAlertMessageProps) => {
    const cancelRef = useRef<HTMLButtonElement>(null);
    return (
        <AlertDialog
            isOpen={isOpen}
            size={size}
            onClose={onCancel}
            leastDestructiveRef={cancelRef}
        >
            <AlertDialogOverlay />
            <AlertDialogContent>
                <AlertDialogCloseButton />
                <AlertDialogBody>{children}</AlertDialogBody>
            </AlertDialogContent>
        </AlertDialog>
    );
};
